import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/auth";
import { useTheme } from "../lib/theme";

export default function AppShell({ children }: { children: React.ReactNode }) {
  const { t, i18n } = useTranslation();
  const { user, logout, hasPermission } = useAuth();
  const { preference, setPreference } = useTheme();

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="topbar-left">
          <span className="topbar-brand">{t("app.title")}</span>
          <nav className="topbar-nav">
            <NavLink to="/dashboard">{t("nav.dashboard")}</NavLink>
            {hasPermission("settings.manage") && <NavLink to="/settings">{t("nav.settings")}</NavLink>}
          </nav>
        </div>
        <div className="topbar-right">
          <select aria-label={t("language.label")} value={i18n.language.split("-")[0]} onChange={(e) => i18n.changeLanguage(e.target.value)}>
            <option value="de">DE</option>
            <option value="en">EN</option>
          </select>
          <select aria-label="Theme" value={preference} onChange={(e) => setPreference(e.target.value as any)}>
            <option value="system">{t("theme.system")}</option>
            <option value="light">{t("theme.light")}</option>
            <option value="dark">{t("theme.dark")}</option>
          </select>
          {user && <span>{user.displayName}</span>}
          <button onClick={() => logout()}>{t("nav.logout")}</button>
        </div>
      </header>
      <main className="content">{children}</main>
    </div>
  );
}
